import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import noimage from "../../assets/img/noimage.png";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../../Actions/common";
import { toast } from "react-toastify";
import { addQuestionaxios, getQuestionAxios } from "../../Actions/axios";

const QuestionAdd = () => {
  const [data, setData] = useState({
    question: {
      "coin supply": [{ question: "hello", description: "world" }],
      "use case": [{ question: "", description: "" }],
    },
    minscore: "",
  });
  const [err, setErr] = useState({});

  const navigate = useNavigate();

  const onChange = (e, Title, i, isDesc, inter) => {
    const { name, value } = e.target;
    let questionData = {};
    let interpretation = [];
    if (inter == "interkey") {
      interpretation = data.interpretation;
      let obj = { [value]: Object.values(Title)[0] };
      interpretation[i] = obj;
    } else if (inter == "interpair") {
      interpretation = data.interpretation;
      let obj = { [`${Object.keys(Title)[0]}`]: value };
      interpretation[i] = obj;
    } else if (!isEmpty(Title)) {
      let questionData = data?.question;
      questionData[`${Title}`][i][isDesc ? "description" : "question"] = value;
    } else if (isEmpty(name)) {
      let allKeys = Object.keys(data?.question);
      let allValues = Object.values(data?.question);
      allKeys?.map((keyData, ind) => {
        if (i == ind) {
          questionData[`${value}`] = allValues[ind];
        } else {
          questionData[`${keyData}`] = allValues[ind];
        }
      });
    }
    setData({
      ...data,
      ...(!isEmpty(questionData)
        ? { question: questionData }
        : !isEmpty(name)
        ? { [name]: value }
        : { interpretation }),
    });
  };

  const addQuestion = (title) => {
    let temp = data?.question;
    if (
      isEmpty(temp[title][temp[title]?.length - 1]?.question) ||
      isEmpty(temp[title][temp[title]?.length - 1]?.description)
    ) {
      return toast.error("Please Fill Last Question and Description");
    }
    temp[title] = [...temp[title], { question: "", description: "" }];
    setData({ ...data, question: temp });
  };

  const addIntreption = () => {
    let temp = data.interpretation;
    temp.push({ "": "" });
    setData({ ...data, interpretation: temp });
  };

  const removeInterpretation = (i) => {
    let temp = data.interpretation;
    temp.splice(i, 1);
    setData({ ...data, interpretation: temp });
  };

  const removeQuestion = (title, i) => {
    let temp = data?.question;
    temp[title].splice(i, 1);
    setData({ ...data, question: temp });
  };

  const addTitle = () => {
    let temp = data?.question;
    let allkeys = Object.keys(temp);
    let allvalues = Object.values(temp);
    let err = {};
    allkeys.map((keyData, i) => {
      if (isEmpty(keyData)) {
        err["key"] = "Title Required";
      }
      if (
        allvalues[i]?.some(
          (ques) => isEmpty(ques?.question) || isEmpty(ques?.description)
        )
      ) {
        err["value"] = "Question Required";
      }
    });
    if (!isEmpty(err)) {
      return toast.error("Please Fill all Inputs");
    }
    temp[""] = [{ question: "", description: "" }];
    setData({ ...data, question: temp });
  };

  const removeTitle = (title, i) => {
    let temp = data?.question;
    delete temp[title];
    setData({ ...data, question: temp });
  };

  const validation = async () => {
    let err = {};
    if (isEmpty(data?.minscore)) {
      err.minscore = "Minimum Score Required";
    }
    await Promise.all(
      Object.keys(data?.question)?.map(async (keyData) => {
        if (isEmpty(keyData)) {
          err[`${keyData}`] = `Title Required`;
        }
        await Promise.all(
          data?.question[`${keyData}`]?.map((ques, i) => {
            if (isEmpty(ques?.question)) {
              if (!err["ques"]) {
                err["ques"] = {};
              }
              if (err["ques"][`${keyData}`]) {
                err["ques"][`${keyData}`][i] = {
                  ...err["ques"][`${keyData}`][i],
                  question: "Question Required",
                };
              } else {
                err["ques"][`${keyData}`] = [{ question: "", description: "" }];
                err["ques"][`${keyData}`][i] = {
                  ...err["ques"][`${keyData}`][i],
                  question: "Question Required",
                };
              }
            }

            if (isEmpty(ques?.description)) {
              if (!err["ques"]) {
                err["ques"] = {};
              }
              if (err["ques"][`${keyData}`]) {
                err["ques"][`${keyData}`][i] = {
                  ...err["ques"][`${keyData}`][i],
                  description: "description Required",
                };
              } else {
                err["ques"][`${keyData}`] = [{ question: "", description: "" }];
                err["ques"][`${keyData}`][i] = {
                  ...err["ques"][`${keyData}`][i],
                  description: "description Required",
                };
              }
            }
          })
        );
      })
    );
    await Promise.all(
      data?.interpretation.map((val, i) => {
        let key = Object.keys(val)[0];
        let value = Object.values(val)[0];
        if (isEmpty(key)) {
          if (!err?.interpretation) {
            err.interpretation = [];
          }
          err.interpretation[i] = {
            "Interpretation Required": err?.interpretation[i]
              ? Object.values(err?.interpretation[i])[0] ?? ""
              : "",
          };
        }
        if (isEmpty(value)) {
          if (!err?.interpretation) {
            err.interpretation = [];
          }
          err.interpretation[i] = {
            [err?.interpretation[i]
              ? Object.keys(err?.interpretation[i])[0] ?? ""
              : ""]: "TotalScore Required",
          };
        }
      })
    );
    setErr(err);
    return err;
  };

  const saveQuestion = async () => {
    let err = await validation();
    console.log("🚀 ~ saveQuestion ~ err:", err);
    if (!isEmpty(err)) {
      return toast.error("Please Fill All Inputs");
    }
    let resp = await addQuestionaxios(data);
    console.log("🚀 ~ saveQuestion ~ resp:", resp);
    if (resp?.status) {
      toast.success(resp?.message);
      getQuestion();
    }
  };

  const getQuestion = async () => {
    let resp = await getQuestionAxios();
    console.log("🚀 ~ getQuestion ~ resp:", resp);
    if (resp?.status) {
      setData(resp?.data);
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);

  return (
    <div className="cmsadd">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>
      <h1 className="pagehead">Question Detail</h1>
      <div className="cardbox">
        <Form>
          <Row>
            {Object.keys(data?.question)?.map((val, i) => {
              return (
                <>
                  <Col xs={12} sm={12} md={4} lg={4} className="mb-4">
                    <Form.Group>
                      <Form.Label>Title</Form.Label>
                      <Form.Control
                        type="text"
                        value={val}
                        onChange={(e) => onChange(e, "", i)}
                      />
                      {err?.[`${val}`] && <p>{err?.[`${val}`]}</p>}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={8} lg={8} className="mb-4">
                    {data?.question[val]?.map((obj, ind) => (
                      <div className="d-block d-sm-flex gap-3 align-items-end mb-3">
                        <Form.Group className="w-100">
                          <Form.Label>Question {ind + 1}</Form.Label>
                          <Form.Control
                            type="text"
                            className="w-100"
                            value={obj?.question}
                            onChange={(e) => onChange(e, val, ind)}
                          />
                          {err?.["ques"]?.[`${val}`]?.[ind]?.question && (
                            <p>{err?.["ques"][`${val}`]?.[ind]?.question}</p>
                          )}
                        </Form.Group>

                        <Form.Group className="w-100 mt-2 mt-sm-0">
                          <Form.Label>Description {ind + 1}</Form.Label>
                          <Form.Control
                            type="text"
                            className="w-100"
                            value={obj?.description}
                            onChange={(e) => onChange(e, val, ind, true)}
                          />
                          {err?.["ques"]?.[`${val}`]?.[ind]?.description && (
                            <p>{err?.["ques"][`${val}`]?.[ind]?.description}</p>
                          )}
                        </Form.Group>

                        <div className="d-flex gap-2 mt-2 mt-sm-0">
                          {data?.question[val]?.length - 1 == ind ? (
                            <>
                            <button
                            className="btn btn-danger"
                            type="button"
                            onClick={() => removeQuestion(val, ind)}
                          >
                            Remove
                          </button>
                          <button
                              className="btn sitebtn"
                              type="button"
                              onClick={() => addQuestion(val)}
                            >
                              ADD
                            </button>
                            </>
                            
                          ) : (
                            <button
                              className="btn btn-danger"
                              type="button"
                              onClick={() => removeQuestion(val, ind)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </Col>
                  <div className="text-end mb-4 d-flex justify-content-center gap-2">
                    {Object.keys(data?.question)?.length - 1 == i ? (
                      <>
                      <button
                        className="btn btn-danger w_200"
                        type="button"
                        onClick={() => removeTitle(val, i)}
                      >
                        Remove
                      </button>
                      <button
                        className="btn sitebtn w_200"
                        type="button"
                        onClick={() => addTitle()}
                      >
                        ADD Title
                      </button>
                      </>
                      
                    ) : (
                      <div className="text-center w-100">
                      <button
                        className="btn btn-danger w_200"
                        type="button"
                        onClick={() => removeTitle(val, i)}
                      >
                        Remove
                      </button>
                      </div>
                    )}
                  </div>
                </>
              );
            })}


 
             <div className="bgback rounded-2 px-3 py-3 mb-4 mt-3 mx-2">
            {data?.interpretation?.length > 0 &&
              Array.isArray(data?.interpretation) &&
              data?.interpretation?.map((val, ind) => (
                <Col xs={12} sm={12} md={10} lg={10} className="mb-4">
                  <div className="d-flex gap-3 align-items-end mb-3">
                    <Form.Group className="w-100">
                      {ind == 0 && (
                        <Form.Label className="fw-600 mb-2">Investment Interpretation</Form.Label>
                      )}
                      <Form.Control
                        type="text"
                        className="w-100"
                        value={Object.keys(val)[0]}
                        onChange={(e) => onChange(e, val, ind, "", "interkey")}
                      />
                      {err?.["interpretation"]?.[ind] &&
                        Object.keys(err?.["interpretation"]?.[ind])[0] !=
                          "" && (
                          <p>
                            {Object.keys(err?.["interpretation"]?.[ind])[0]}
                          </p>
                        )}
                    </Form.Group>

                    <Form.Group className="w-100">
                      {ind == 0 && <Form.Label className="fw-600 mb-2">Total Scores</Form.Label>}
                      <Form.Control
                        type="text"
                        className="w-100"
                        value={Object.values(val)[0]}
                        onChange={(e) => onChange(e, val, ind, "", "interpair")}
                      />
                      {err?.["interpretation"]?.[ind] &&
                        Object.values(err?.["interpretation"]?.[ind])[0] !=
                          "" && (
                          <p>
                            {Object.values(err?.["interpretation"]?.[ind])[0]}
                          </p>
                        )}
                    </Form.Group>

                    <div className="d-flex gap-2">
                      {data?.interpretation?.length - 1 == ind ? (
                        <>
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => removeInterpretation(ind)}
                        >
                          Remove
                        </button>
                        <button
                          className="btn sitebtn"
                          type="button"
                          onClick={() => addIntreption()}
                        >
                          ADD
                        </button>
                        </>
                        
                      ) : (
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => removeInterpretation(ind)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                </Col>
              ))}
            <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
              <Form.Group>
                <Form.Label>Minimum Score</Form.Label>
                <Form.Control
                  type="text"
                  name="minscore"
                  value={data?.minscore}
                  onChange={onChange}
                />
                {err?.minscore && <p>{err.minscore}</p>}
              </Form.Group>
            </Col>
              </div>
          </Row>
        </Form>
        <button
          type="button"
          onClick={() => saveQuestion()}
          className="btn sitebtn py-2 px-3"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default QuestionAdd;
